import React from "react";

const EditorSettingsContext = React.createContext({});
export default EditorSettingsContext;




